export const isIOS = (): boolean =>
  typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isAndroid = (): boolean => /android/i.test(navigator.userAgent);
export const isPWA = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia('(display-mode: standalone)').matches;

export const isPC = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia('(min-width: 768px)').matches;

/** Runtime check: viewport is smaller than Tailwind `md` */
export const isMobile = (): boolean => !isPC();
